<div class="fx-layout-column">
  <div class="fx-flex">
    <!-- Navigation with Pill Tabs (Desktop) and Dropdown (Mobile) -->
    <nav class="bg-[#2a3a6c] flex items-center justify-between px-4 py-2.5 gap-3">
      <!-- Desktop: Block Tabs Navigation with TTS Icon -->
      <div class="hidden md:flex items-center justify-center gap-2 flex-1 min-w-0 overflow-x-auto">
        <a *ngFor="let link of links" 
          [routerLink]="link.path" 
          routerLinkActive #rla="routerLinkActive"
          class="px-4 py-2 rounded text-sm font-medium whitespace-nowrap transition-all duration-200 flex-shrink-0"
          [class.bg-white]="rla.isActive"
          [class.text-[#2a3a6c]]="rla.isActive"
          [class.text-white]="!rla.isActive"
          [class.hover:bg-white]="!rla.isActive"
          [class.hover:bg-opacity-20]="!rla.isActive"
          [class.shadow-md]="rla.isActive">
          {{link.label}}
        </a>
        <!-- Text to Speech Icon next to chapter navigation -->
        <app-text-to-speech *ngIf="links && links.length > 0"></app-text-to-speech>
      </div>

      <!-- Mobile: Dropdown Menu with TTS Icon -->
      <div class="md:hidden flex items-center gap-2 flex-1 min-w-0">
        <!-- Hamburger Menu Icon -->
        <button (click)="toggleChapterSection()" 
          class="flex-shrink-0 flex items-center justify-center h-[42px] w-[42px] text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200"
          aria-label="Toggle chapter sections">
          <mat-icon>{{isChapterSectionOpen ? 'close' : 'menu'}}</mat-icon>
        </button>
        
        <div class="relative flex-1 min-w-0">
          <button (click)="toggleChapterDropdown()" 
            class="w-full flex items-center justify-between px-4 py-2 h-[42px] bg-white text-[#2a3a6c] rounded-lg text-sm font-medium shadow-sm hover:shadow-md transition-all duration-200">
            <span class="truncate text-sm">
              {{getActiveChapterLabel() || 'Select Chapter'}}
            </span>
            <mat-icon class="ml-2 flex-shrink-0">{{isChapterDropdownOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
          </button>
          
          <!-- Dropdown Menu -->
          <div *ngIf="isChapterDropdownOpen" 
            class="absolute left-0 right-0 mt-2 bg-white rounded-lg shadow-lg z-50 border border-gray-200 max-h-96 overflow-y-auto">
            <div class="py-1">
              <a *ngFor="let link of links" 
                [routerLink]="link.path" 
                routerLinkActive #rla="routerLinkActive"
                (click)="closeChapterDropdown()"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-[#2a3a6c] hover:text-white transition-colors duration-200"
                [class.bg-[#2a3a6c]]="rla.isActive"
                [class.text-white]="rla.isActive"
                [class.font-semibold]="rla.isActive">
                {{link.label}}
              </a>
            </div>
          </div>
        </div>
        <!-- Text to Speech Icon next to mobile dropdown -->
        <div class="flex-shrink-0">
          <app-text-to-speech></app-text-to-speech>
        </div>
      </div>      
    </nav>
  </div>
  <!-- Right side controls -->
  <div class="md:flex items-center justify-center gap-2 flex-shrink-0">
    <app-course-timer [showTimer]="true" [showTimerIncomplete]="false" [courseChapters]="courseChapters"
      [courseQuizzes]="courseQuizzes" [progresses]="progresses" *ngIf="courseChapters && courseQuizzes && progresses">
    </app-course-timer>
  </div>
  
  <div class="fx-flex" #courseViewContent>
    <div class="fx-layout-row fx-layout-align-space-evenly-start"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
      *ngIf="(currChapterViewState$ | async)?.currentState === 'ChapterShow' || (currChapterViewState$ | async)?.currentState === 'ChapterFinalShow'">
      <!-- <div #content [innerHTML]="chapterContent" class="chapter-content fx-flex-28pc" routeTransformer
        *ngIf="(currChapterViewState$ | async).currentState !== 'FinalShow' && chapterSections.length == 0"></div> -->
      <div #content class="chapter-content" routeTransformer
        [class.hidden]="!isChapterSectionOpen"
        *ngIf="(currChapterViewState$ | async).currentState !== 'ChapterFinalShow' && chapterSections.length > 0">
        <div class="fx-layout-column">
          <div *ngFor="let section of chapterSections">
            <div class="section" [class.section-selected]="isSectionSelected(section)" *ngIf="!section.parentId || section.parentId == 0">
              <div class="title" *ngIf="section.location"><a [href]="section.location"
                  [target]="section.target ? section.target : '_blank'">{{ section.name }}</a></div>
              <div class="title" *ngIf="!section.location">{{ section.name }}</div>
              <div class="description" *ngIf="section.description">{{ section.description }}</div>
              <div class="hint" *ngIf="section.hint">{{ section.hint }}</div>
            </div>
            <div class="subsection" [class.section-selected]="isSectionSelected(section)" *ngIf="section.parentId && section.parentId != 0">
              <div class="title" *ngIf="section.location && !section.content"><a [href]="section.location"
                  [target]="section.target ? section.target : '_blank'">{{ section.name }}</a></div>
              <div class="title" *ngIf="section.content"><a [href]="getSectionLink(section)">{{ section.name }}</a>
              </div>
              <div class="description" *ngIf="section.description">{{ section.description }}</div>
              <div class="hint" *ngIf="section.hint">{{ section.hint }}</div>
            </div>

          </div>
        </div>
      </div>
      <div class="quiz-content" [class.quiz-content-full]="hasSelectedSection" [class.fx-flex-68pc]="true" (click)="closeChapterSectionOnMobile()">
        <div class="section-content" [innerHTML]="sectionContent" routeTransformer *ngIf="sectionContent"></div>
        <app-quiz-tests #chapters [progresses]="progressesLoaded ? progresses : null"></app-quiz-tests>
      </div>
    </div>

    <div class="fx-layout-row fx-layout-align-space-evenly-start"
      *ngIf="(currChapterViewState$ | async).currentState === 'ChapterQuizzesIncomplete'">
      <div class="final fx-flex-auto" routeTransformer>
        <div #content [innerHTML]="chapterContent" class="chapter-content fx-flex-auto" routeTransformer>
        </div>
      </div>
    </div>

    <app-course-timer [showTimer]="false" [showTimerIncomplete]="true" [courseChapters]="courseChapters"
      [courseQuizzes]="courseQuizzes" [progresses]="progresses"
      *ngIf="courseChapters && courseQuizzes && progresses && (currChapterViewState$ | async).currentState !== 'ChapterQuizzesIncomplete'">
    </app-course-timer>


  </div>
